// Photo filenames for Holiday Party 2015
const HOLIDAY_PARTY_2015_PHOTOS = [
  "christmas-201515_24047584351_z.jpg",
  "christmas-201516_24022080072_z.jpg",
  "christmas-201517_23503388713_z.jpg",
  "christmas-201518_23501961064_z.jpg",
  "christmas-201519_23834533430_m.jpg",
  "christmas-201520_24130187355_z.jpg",
  "christmas-201521_24130187075_l.jpg",
  "christmas-201523_24047582841_z.jpg",
  "christmas-201524_24022079002_z.jpg",
  "christmas-201525_23501960064_z.jpg",
  "christmas-201526_24047582461_z.jpg",
  "christmas-201527_23834532360_c.jpg",
  "christmas-201528_23503386963_l.jpg",
  "christmas-201530_24104090336_z.jpg",
  "christmas-201531_24022077972_z.jpg",
  "christmas-201532_24130185515_z.jpg",
  "christmas-201533_24047581391_c.jpg",
  "christmas-201534_24022077492_c.jpg",
  "christmas-201535_23501958474_z.jpg",
  "christmas-201540_24104089386_z.jpg",
  "christmas-201541_23501958154_l.jpg",
  "christmas-201542_23762381539_z.jpg",
  "christmas-201543_24047580451_l.jpg",
  "christmas-201544_23762381289_z.jpg",
  "christmas-201545_23834530220_z.jpg",
  "christmas-201546_24047579911_z.jpg",
  "christmas-201547_23501957184_z.jpg",
  "christmas-201548_24022075952_z.jpg",
  "christmas-201549_23834529540_z.jpg",
  "christmas-201550_24104087626_z.jpg",
  "christmas-201551_24022075392_c.jpg",
  "christmas-201552_23501956394_z.jpg",
  "christmas-201553_24130182775_z.jpg",
  "christmas-201554_23501956084_l.jpg",
  "christmas-201510_23503389563_z.jpg",
  "christmas-201511_24130188375_z.jpg",
  "christmas-201513_23762385359_z.jpg",
  "christmas-201514_24047584531_z.jpg"
];

export default HOLIDAY_PARTY_2015_PHOTOS;
